import React, { useState, useRef } from 'react';
import * as _ from 'lodash';
import Tippy from '../ReactTippy';

import DropdownSelector from '../dropdowns/DropdownSelector';

// modals
import { Information, Confirmation } from '../modals/common';
import { DirectCommunicationErrorModal } from './DirectCommunicationErrorModal';

//utilities
import { messageUtility } from '../../utilities/messageUtility';
import { STATUS_CODE } from '../../utilities/constants';
import { useFetchDataWithToken } from '../../utilities/useFetchData';

//service
import SessionStorageService from '../../services/utilities/SessionStorageService';
import DirectNoticeUnapprovedWorkSettingsApi from '../../services/DirectNoticeUnapprovedWorkSettingsApi';
import DirectApiSettingsApi from '../../services/DirectApiSettings';

//pages
import { useGetReloadExternalServiceCooperationPage } from '../../pages/ExternalServiceCooperation';
import { useGetDirectNoticeUnapprovedWorkSettingData } from '../../pages/ExternalServiceCooperation';

export default function DirectNoticeSettingModal({ visible, setVisible }) {
  const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
  const reloadAction = useGetReloadExternalServiceCooperationPage();
  const directNoticeUnapprovedWorkSettingData = useGetDirectNoticeUnapprovedWorkSettingData();
  const [
    selectedNoticeUnapprovedWorkSettingData,
    setSelectedNoticeUnapprovedWorkSettingData,
  ] = useState({
    talk_id: directNoticeUnapprovedWorkSettingData.talk_id,
    send_schedule_works_time:
      directNoticeUnapprovedWorkSettingData.send_schedule_works_time,
    send_result_works_time:
      directNoticeUnapprovedWorkSettingData.send_result_works_time,
  });
  const fieldId = SessionStorageService.getFieldId();
  const { data: directTalkroomResponse } = useFetchDataWithToken(
    DirectApiSettingsApi.direct_talkroom_list.list_options({
      field_id: fieldId,
    }),
    DirectApiSettingsApi.direct_talkroom_list.list_default_response()
  );
  const directTalkroomList =
    directTalkroomResponse['data']['entities']['direct_talkrooms'];
  const onConfirm = () => {
    setVisible(false);
    setIsShowConfirmModal(true);
  };
  const onClose = () => {
    setVisible(false);
    reloadAction();
  };

  return (
    <React.Fragment>
      {directNoticeUnapprovedWorkSettingData.isNoticeEnabled() ? (
        <React.Fragment>
          <Confirmation
            visible={visible}
            rootClassName={'DirectDescriptionModal--NoticeSetting'}
            title={messageUtility.getMessage('I-001-573')}
            message={
              <React.Fragment>
                <div className='dialog__text'>
                  {messageUtility.getMessage('I-001-574')}
                </div>
                <NoticeUnapprovedWorkSettingTable
                  directTalkroomList={directTalkroomList}
                  selectedNoticeUnapprovedWorkSettingData={
                    selectedNoticeUnapprovedWorkSettingData
                  }
                  setSelectedNoticeUnapprovedWorkSettingData={
                    setSelectedNoticeUnapprovedWorkSettingData
                  }
                />
              </React.Fragment>
            }
            confirmButtonText={messageUtility.getMessage('I-000-080')}
            cancelButtonText={messageUtility.getMessage('I-000-008')}
            onConfirm={onConfirm}
            disabledConfirmButton={
              selectedNoticeUnapprovedWorkSettingData.talk_id === null
            }
            onCancel={onClose}
            tabFocus={true}
          />
          <DirectNoticeSettingConfirmModal
            visible={isShowConfirmModal}
            setVisible={setIsShowConfirmModal}
            onBack={() => {
              setVisible(true);
            }}
            onClose={onClose}
            selectedNoticeUnapprovedWorkSettingData={
              selectedNoticeUnapprovedWorkSettingData
            }
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Information
            visible={visible}
            rootClassName={'DirectDescriptionModal--UnuseNoticeInfomation'}
            title={messageUtility.getMessage('I-001-575')}
            message={messageUtility.getMessage('I-001-576')}
            buttonText={messageUtility.getMessage('I-000-017')}
            onClose={() => {
              setVisible(false);
              onClose();
            }}
            tabFocus={true}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

function NoticeUnapprovedWorkSettingTable({
  directTalkroomList,
  selectedNoticeUnapprovedWorkSettingData,
  setSelectedNoticeUnapprovedWorkSettingData,
}) {
  return (
    <div className='manage-table'>
      <RenderShowTableHeader />
      <RenderShowTableBody
        directTalkroomList={directTalkroomList}
        selectedNoticeUnapprovedWorkSettingData={
          selectedNoticeUnapprovedWorkSettingData
        }
        setSelectedNoticeUnapprovedWorkSettingData={
          setSelectedNoticeUnapprovedWorkSettingData
        }
      />
    </div>
  );
}
function RenderShowTableHeader() {
  return (
    <table className='table'>
      <thead className='table__header'>
        <tr className='table__label'>
          <td className='value-table value-table__radio_button'></td>
          <td className='value-table value-table__direct_talkroom_name'>
            {'トークルーム'}
          </td>
          <td className='value-table value-table__send_works_time'>
            {'作業予定　通知時間'}
          </td>
          <td className='value-table value-table__send_works_time'>
            {'作業実績　通知時間'}
          </td>
          <td className='value-table value-table__after_space' />
        </tr>
      </thead>
    </table>
  );
}

function RenderShowTableBody({
  directTalkroomList,
  selectedNoticeUnapprovedWorkSettingData,
  setSelectedNoticeUnapprovedWorkSettingData,
}) {
  return (
    <div className='manage-element'>
      <table className='table'>
        <tbody className='table__body'>
          {_.map(directTalkroomList, directTalkroom => (
            <RenderShowTableBodyRow
              directTalkroom={directTalkroom}
              selectedNoticeUnapprovedWorkSettingData={
                selectedNoticeUnapprovedWorkSettingData
              }
              setSelectedNoticeUnapprovedWorkSettingData={
                setSelectedNoticeUnapprovedWorkSettingData
              }
              key={directTalkroom['talk_id']}
            />
          ))}
          {_.isEmpty(directTalkroomList) && (
            <tr className='table-has-no-data'>
              <td className='table-has-no-data__message'>
                表示できるトークルームはありません
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

function RenderShowTableBodyRow({
  directTalkroom,
  selectedNoticeUnapprovedWorkSettingData,
  setSelectedNoticeUnapprovedWorkSettingData,
}) {
  const works_time_options = [
    {
      works_time_name: '0時頃',
      works_time: '00:00:00',
    },
    {
      works_time_name: '1時頃',
      works_time: '01:00:00',
    },
    {
      works_time_name: '2時頃',
      works_time: '02:00:00',
    },
    {
      works_time_name: '3時頃',
      works_time: '03:00:00',
    },
    {
      works_time_name: '4時頃',
      works_time: '04:00:00',
    },
    {
      works_time_name: '5時頃',
      works_time: '05:00:00',
    },
    {
      works_time_name: '6時頃',
      works_time: '06:00:00',
    },
    {
      works_time_name: '7時頃',
      works_time: '07:00:00',
    },
    {
      works_time_name: '8時頃',
      works_time: '08:00:00',
    },
    {
      works_time_name: '9時頃',
      works_time: '09:00:00',
    },
    {
      works_time_name: '10時頃',
      works_time: '10:00:00',
    },
    {
      works_time_name: '11時頃',
      works_time: '11:00:00',
    },
    {
      works_time_name: '12時頃',
      works_time: '12:00:00',
    },
    {
      works_time_name: '13時頃',
      works_time: '13:00:00',
    },
    {
      works_time_name: '14時頃',
      works_time: '14:00:00',
    },
    {
      works_time_name: '15時頃',
      works_time: '15:00:00',
    },
    {
      works_time_name: '16時頃',
      works_time: '16:00:00',
    },
    {
      works_time_name: '17時頃',
      works_time: '17:00:00',
    },
    {
      works_time_name: '18時頃',
      works_time: '18:00:00',
    },
    {
      works_time_name: '19時頃',
      works_time: '19:00:00',
    },
    {
      works_time_name: '20時頃',
      works_time: '20:00:00',
    },
    {
      works_time_name: '21時頃',
      works_time: '21:00:00',
    },
    {
      works_time_name: '22時頃',
      works_time: '22:00:00',
    },
    {
      works_time_name: '23時頃',
      works_time: '23:00:00',
    },
  ];

  const selectedRow =
    selectedNoticeUnapprovedWorkSettingData.talk_id ===
    directTalkroom['talk_id'];
  const _setSelectedNoticeUnapprovedWorkSettingData = (name, value) => {
    switch (name) {
      case 'talk_id':
        if (selectedRow) {
          return;
        } else {
          // 別のトークルームIDを選択した時の初期値は必ず17:00とする
          setSelectedNoticeUnapprovedWorkSettingData({
            talk_id: directTalkroom['talk_id'],
            send_schedule_works_time: '17:00:00',
            send_result_works_time: '17:00:00',
          });
        }
        break;
      case 'send_schedule_works_time':
        if (selectedRow) {
          setSelectedNoticeUnapprovedWorkSettingData({
            talk_id: selectedNoticeUnapprovedWorkSettingData.talk_id,
            send_schedule_works_time: value,
            send_result_works_time:
              selectedNoticeUnapprovedWorkSettingData.send_result_works_time,
          });
        }
        break;
      case 'send_result_works_time':
        if (selectedRow) {
          setSelectedNoticeUnapprovedWorkSettingData({
            talk_id: selectedNoticeUnapprovedWorkSettingData.talk_id,
            send_schedule_works_time:
              selectedNoticeUnapprovedWorkSettingData.send_schedule_works_time,
            send_result_works_time: value,
          });
        }
        break;
    }
  };
  return (
    <tr className={'table__item'}>
      <td
        className='value-table value-table__radio_button'
        onClick={() => {
          _setSelectedNoticeUnapprovedWorkSettingData(
            'talk_id',
            directTalkroom['talk_id']
          );
        }}
      >
        <div className='value-table__icon'>
          <label className='checkbox'>
            {/* readOnlyを入れておかないと開発者コンソールで警告が出る */}
            <input
              className='input-radio'
              type='radio'
              checked={selectedRow}
              readOnly={true}
            />
          </label>
        </div>
      </td>
      <td
        className='value-table value-table__direct_talkroom_name'
        onClick={() => {
          _setSelectedNoticeUnapprovedWorkSettingData(
            'talk_id',
            directTalkroom['talk_id']
          );
        }}
      >
        <RowToolTip
          html={
            <div className='direct-tooltip-content'>
              {directTalkroom['name']}
            </div>
          }
        >
          <div className='value-table__text'>{directTalkroom['name']}</div>
        </RowToolTip>
      </td>
      <td className='value-table value-table__send_works_time'>
        {selectedRow ? (
          <DropdownSelector
            label='17時頃'
            selectorName='send_schedule_works_time'
            selectedValues={
              selectedNoticeUnapprovedWorkSettingData.send_schedule_works_time
            }
            keyName='works_time_name'
            valueName='works_time'
            options={works_time_options}
            onSelect={_setSelectedNoticeUnapprovedWorkSettingData}
          />
        ) : (
          <DropdownSelector
            label='17時頃'
            isDisabled={true}
            selectorName='send_schedule_works_time'
            selectedValues={'17:00:00'}
            keyName='works_time_name'
            valueName='works_time'
            options={works_time_options}
          />
        )}
      </td>
      <td className='value-table value-table__send_works_time'>
        {selectedRow ? (
          <DropdownSelector
            label='17時頃'
            selectorName='send_result_works_time'
            selectedValues={
              selectedNoticeUnapprovedWorkSettingData.send_result_works_time
            }
            keyName='works_time_name'
            valueName='works_time'
            options={works_time_options}
            onSelect={_setSelectedNoticeUnapprovedWorkSettingData}
          />
        ) : (
          <DropdownSelector
            label='17時頃'
            isDisabled={true}
            selectorName='send_result_works_time'
            selectedValues={'17:00:00'}
            keyName='works_time_name'
            valueName='works_time'
            options={works_time_options}
          />
        )}
      </td>
    </tr>
  );
}

function RowToolTip({ children, html }) {
  return (
    <Tippy
      duration={10}
      distance={24}
      arrow='true'
      arrowType='sharp'
      delay={[500, 0]}
      placement='bottom'
      followCursor={true}
      html={html}
    >
      {children}
    </Tippy>
  );
}

function DirectNoticeSettingConfirmModal({
  visible,
  setVisible,
  onBack,
  onClose,
  selectedNoticeUnapprovedWorkSettingData,
}) {
  const [isShowErrorModal, setIsShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const isSending = useRef(false);
  const onConfirm = async () => {
    if (isSending.current) {
      return;
    }
    isSending.current = true;
    try {
      const fieldId = SessionStorageService.getFieldId();
      const {
        data,
        result,
        status,
      } = await DirectNoticeUnapprovedWorkSettingsApi.create(fieldId, {
        talk_id: selectedNoticeUnapprovedWorkSettingData.talk_id,
        send_schedule_works_time:
          selectedNoticeUnapprovedWorkSettingData.send_schedule_works_time,
        send_result_works_time:
          selectedNoticeUnapprovedWorkSettingData.send_result_works_time,
      });
      setVisible(false);
      if (!result || status === STATUS_CODE.badRequest) {
        setErrorMessage(_.get(data, 'message', null));
        setIsShowErrorModal(true);
        return;
      }
      onClose();
    } catch (error) {
      setIsShowErrorModal(true);
    } finally {
      isSending.current = false;
    }
  };
  return (
    <React.Fragment>
      <Confirmation
        visible={visible}
        rootClassName={'DirectDescriptionModal--NoticeSettingConfirm'}
        title={messageUtility.getMessage('I-001-573')}
        message={messageUtility.getMessage('I-001-579')}
        confirmButtonText={messageUtility.getMessage('I-000-054')}
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        onConfirm={onConfirm}
        onCancel={() => {
          setVisible(false);
          onBack();
        }}
        tabFocus={true}
      />
      <DirectCommunicationErrorModal
        visible={isShowErrorModal}
        setVisible={setIsShowErrorModal}
        errorMessage={errorMessage}
        closeAction={onClose}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/externalService/DirectNoticeSettingModal.jsx